import { action } from 'satcheljs';
import { CloudFile } from 'owa-attachment-file-types';

export const addInsertLinkViewState = action(
    'ADD_INSERT_LINK_VIEW_STATE',
    (linkId: string, file: CloudFile) => ({
        linkId: linkId,
        file: file,
    })
);

export const removeInsertLinkViewState = action(
    'REMOVE_INSERT_LINK_VIEW_STATE',
    (linkId: string) => ({
        linkId: linkId,
    })
);

export const onSharingLinkRetrivalFailure = action(
    'ON_SHARING_LINK_RETRIVAL_FAILURE',
    (linkId: string) => ({
        linkId: linkId,
    })
);

export const onStartRetrievingSharingLink = action(
    'ON_START_RETRIEVING_SHARING_LINK',
    (linkId: string) => ({
        linkId: linkId,
    })
);
